import client from "./client";
import { saveBlob } from "../lib/saveBlob";
import { actionLoc } from "../lib/actionLoc";

export const myNotifications = async () => (await client.get("/notifications")).data;
export const readAllNotifications = async () => (await client.post("/notifications/read-all")).data;
export const readNotification = async (id) => (await client.post(`/notifications/${id}/read`)).data;

export const leaveBalance = async () => (await client.get("/hr/leaves/balance")).data;
export const leaveCalendar = async (month) => (await client.get("/hr/leaves/calendar", { params: { month } })).data;
export const uploadCertificate = async (file) => {
  const data = new FormData();
  data.append("file", file);
  return (await client.post("/files/certificate", data, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const requestLeave = async (body) => (await client.post("/hr/leaves", body)).data;
export const leaveConflicts = async (id) => (await client.get(`/hr/leaves/${id}/conflicts`)).data;
export const attachCertificate = async (id, url) =>
  (await client.patch(`/hr/leaves/${id}/certificate`, { certificate_url: url })).data;

export const myPayslip = async (month) =>
  (await client.get("/payroll/my-payslip", { params: { month } })).data;
export const payrollRun = async (month, branchId, userId) =>
  (await client.get("/payroll/run", {
    params: { month, branch_id: branchId, user_id: userId || undefined },
  })).data;
export const finalizePayroll = async (month) =>
  (await client.post("/payroll/finalize", null, { params: { month } })).data;
export const addAdjustment = async (userId, body) =>
  (await client.post(`/payroll/adjustments/${userId}`, body)).data;

export const salaryReport = async (params) =>
  (await client.get("/payroll/report", { params })).data;
export const payrollProgress = async (month, branchId) =>
  (await client.get("/payroll/progress", { params: { month, branch_id: branchId || undefined } })).data;
export const payrollCycle = async (month, branchId) =>
  (await client.get("/payroll/cycle", { params: { month, branch_id: branchId || undefined } })).data;
export const announcePayroll = async (body) =>
  (await client.post("/payroll/cycle/announce", body)).data;
export const disbursePayroll = async (month, branchId) =>
  (await client.post("/payroll/cycle/disburse", null, {
    params: { month, branch_id: branchId || undefined },
  })).data;
export const listPayrollArchive = async (month) =>
  (await client.get("/payroll/archive", { params: { month } })).data;
export const listSealedPayroll = async (month) =>
  (await client.get("/payroll/sealed", { params: month ? { month } : {} })).data;
export const archivePayroll = async (params) =>
  (await client.post("/payroll/archive", null, { params })).data;
export const myPayrollCycle = async (month) =>
  (await client.get("/payroll/cycle/mine", { params: { month } })).data;
export const acknowledgeSalary = async (month) =>
  (await client.post("/payroll/cycle/mine/acknowledge", await actionLoc(), { params: { month } })).data;

export const reportSalaryNotReceived = async (month, reason) =>
  (await client.post("/payroll/cycle/mine/not-received", { reason, ...(await actionLoc()) }, { params: { month } })).data;
export const downloadReport = async (path, params, name) => {
  const res = await client.get(path, { params, responseType: "blob" });
  await saveBlob(res.data, name);
};
export const customSalaryReport = async (params) =>
  (await client.get("/payroll/report/custom", { params })).data;

export const downloadPayslipPdf = async (month, lang, userId) => {
  const path = userId ? `/payroll/payslip-pdf/${userId}` : "/payroll/my-payslip-pdf";
  const res = await client.get(path, { params: { month, lang }, responseType: "blob" });
  await saveBlob(res.data, `payslip-${month}.pdf`);
};
